/* unplugin-vue-components disabled */import { ElTable as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElTag as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/tag/style/css';
import { ElTableColumn as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElForm as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_2 from '/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadioButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio-button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "agreement-manage"
};
const _hoisted_2 = {
  class: "flex justify-between"
};
const _hoisted_3 = {
  key: 0
};
import AgreementModal from './modules/agreementModal.vue';
import useAgreementGetDataTable from './modules/useAgreementGetDataTable';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'agreement',
  setup(__props) {
    const gameInfo = computed(() => useAppStore().gameInfo);
    const agreementModalRef = ref();
    const {
      tabType,
      filter,
      tableData,
      tableLoading,
      getTableData
    } = useAgreementGetDataTable();
    const handleChangeTab = () => {
      filter.value.cid = undefined;
      tableData.value = [];
      getTableData();
    };
    const handleOpenConf = row => {
      agreementModalRef.value.show({
        channel: row,
        gid: gameInfo.value.Id,
        tabType: tabType.value,
        type: 'edit'
      });
    };
    watch(() => gameInfo.value, val => {
      if (val && val.Id) {
        getTableData();
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_radio_button = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      const _component_GameChannelSelect = __unplugin_components_2;
      const _component_el_form_item = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_form = __unplugin_components_5;
      const _component_el_table_column = __unplugin_components_6;
      const _component_el_tag = __unplugin_components_7;
      const _component_el_table = __unplugin_components_8;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_radio_group, {
        modelValue: _unref(tabType),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(tabType) ? tabType.value = $event : null),
        onChange: handleChangeTab
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          label: 1
        }, {
          default: _withCtx(() => [_createTextVNode("游戏协议")]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          label: 2
        }, {
          default: _withCtx(() => [_createTextVNode("注销协议")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "所属渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_GameChannelSelect, {
            modelValue: _unref(filter).cid,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).cid = $event),
            gid: _unref(gameInfo).Id,
            otherProps: {
              isGlobal: 1
            }
          }, null, 8, ["modelValue", "gid"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "marginL20",
            type: "primary",
            onClick: _unref(getTableData)
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      })]), _createVNode(_component_el_table, {
        data: _unref(tableData),
        loading: _unref(tableLoading)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "cid",
          label: "渠道ID",
          width: 200
        }), _createVNode(_component_el_table_column, {
          prop: "cname",
          label: "渠道名称",
          width: 200
        }), _unref(tabType) === 1 ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: "val_13",
          label: "协议弹窗开关",
          width: 200
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tag, {
            type: scope.row.enable ? 'success' : 'info'
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.enable ? '已开启' : '已关闭'), 1)]),
            _: 2
          }, 1032, ["type"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          key: "val_14",
          label: "协议配置"
        }, {
          default: _withCtx(scope => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.agreements.slice(0, 5), lang => {
            return _openBlock(), _createBlock(_component_el_tag, {
              class: "marginR5",
              key: lang.id
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(lang.lang), 1)]),
              _: 2
            }, 1024);
          }), 128)), scope.row.agreements.length > 5 ? (_openBlock(), _createElementBlock("span", _hoisted_3, "...")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: 200
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            onClick: $event => handleOpenConf(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("配置")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "loading"])]), _createVNode(AgreementModal, {
        ref_key: "agreementModalRef",
        ref: agreementModalRef,
        onSuccess: _unref(getTableData)
      }, null, 8, ["onSuccess"])], 64);
    };
  }
});